import { render, staticRenderFns } from "./ABenhAn.vue?vue&type=template&id=5cd6f5dd&scoped=true"
import script from "./ABenhAn.vue?vue&type=script&lang=js"
export * from "./ABenhAn.vue?vue&type=script&lang=js"
import style0 from "./ABenhAn.vue?vue&type=style&index=0&id=5cd6f5dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd6f5dd",
  null
  
)

export default component.exports